module.exports = __webpack_public_path__ + "img/2_13.9e350cb1.png";